<template>
  <div class="page-content">
    <div class="page-title">
      <h5>实践考核</h5>
    </div>
    <div class="">
      <div class="panel">
        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
          <tbody>
            <template v-if="configs">
              <tr>
                <th style="width: 200px">批次 :</th>
                <td>
                  <el-select size="mini" v-model="defaultThesisBatchId" @change="getInfo">
                    <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </td>
              </tr>
            </template>

           
            <template v-if="chooseCourse && config&&config.id">
              <tr>
                <th>报告上传时间 :</th>
                <td>{{ config.reportStartTime }}-{{ config.reportEndTime }}</td>
              </tr>
              <tr>
                <th>状态 :</th>
                <td>
                  {{info.status}}
                </td>
              </tr>

              <tr>
                <th>主考学校 :</th>
                <td><span v-if="info.school">{{ info.school.code }}-{{ info.school.name }}</span></td>
              </tr>


              <tr>
                <th>专业 :</th>
                <td><span v-if="info.specialty">{{ info.specialty.code }}-{{ info.specialty.name }}</span></td>
              </tr>
              <tr>
                <th>课程 :</th>
                <td><span v-if="info.course">{{ info.course.code }}-{{ info.course.name }}</span></td>
              </tr>
              <template>
                <tr>
                  <th>实践报告 :</th>
                  <td>
                    <template v-if="chooseCourse.reportAtt">
                      <span id="chugaoInfo">
                        <a :href="chooseCourse.reportAtt" target="_blank">查看</a>
                      </span>
                      <Upload style="display: none" @success="UploadChange($event, 'chugao')"
                        url="/comm/upload" accept=".doc,.docx,.pdf,.ppt" id="btn_upload_chugao" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chugao')" v-if="isDate">重传</el-button>
                    </template>
                    <template v-else>
                      <Upload style="display: none" @success="UploadChange($event, 'chugao')"
                        url="/comm/upload" accept=".doc,.docx,.pdf,.ppt" id="btn_upload_chugao" />
                      <el-button type="primary" size="mini" @click="beforeUpload('chugao')" v-if="isDate">请上传</el-button>
                    </template>
                    <br />

                    <div style="color: red" >
                      （支持word，ppt，pdf文件）
                    </div>
                  </td>
                </tr>
                <tr v-if="chooseCourse.score">
                  <th style="width: 200px">成绩</th>
                  <td>
                    {{ chooseCourse.score }}
                  </td>
                </tr>
                <template v-if="isDate">
                  <tr>
                    <th>操作 :</th>
                    <td>
                      <el-button size="mini" class="send" type="primary" @click="toSubmit">
                        提交
                      </el-button>
                    </td>
                  </tr>
                </template>
              </template>

            </template>
           

          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "MySpotCheck",
  components: {
    UploadImage: () => import("@/components/UploadImage.vue"),
  },
  data() {
    return {
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      logs: [],
      bm: null,
      curTime: new Date().getTime(),
      nowDate: new Date().getTime(),
      form: {},
      submitToAudit: {
        attPath: "",
        attSize: "",
        atname: "",
        remark: "",
        thesisId: "",
        operType: 1,
      },
      chooseCourse: {},
      isDate:false
    };
  },
  created() {
    if (this.$route.query.practiceTconfigId) this.defaultThesisBatchId = +this.$route.query.practiceTconfigId;
    this.getInfo();
  },
  beforeDestroy() {
  },
  methods: {
    openFile(item) {
      const a = document.createElement("a");
      a.href = item.attPath;
      a.target = "_blank";
      a.download =
        "https://view.officeapps.live.com/op/view.aspx?src=" + item.atname;
      a.style.display = "none";
      document.body.append(a);
      a.click();
      document.body.removeChild(a); // 移除
    },
    upload() {
      //模拟点击上传图片
      document.getElementById("fileBtn").click();
    },
    uploadFn() {
      var fileName = this.$refs.file.files[0].name;
      var suffix = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
      if (
        !(
          suffix == ".doc" ||
          suffix == ".docx" ||
          suffix == ".pdf" ||
          suffix == ".xls" ||
          suffix == ".xlsx"
        )
      ) {
        this.$message.error("文件格式不正确");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      formData.append("thesisId", this.thesis.id);
      this.UploadChange_other(formData);
    },
    UploadChange_other(formData) {
      var that = this;
      that.$http
        .post("/student/thesis2/uploadAtt2", formData, {
          "Content-Type": "multipart/form-data",
        })
        .then(res => {
          this.$message.success("上传成功");
          this.getInfo();
        });
    },
    getInfo() {
      let isDate=false
      this.$http
        .get("/student/practiceReport/detail", { practiceTconfigId: this.defaultThesisBatchId })
        .then(res => {
          this.config = res.currentBatch;
          this.configs = res.batches;
          this.info = res;
          if (!this.defaultThesisBatchId) this.defaultThesisBatchId = res.currentBatch.id;
          this.chooseCourse = res.chooseCourse;
          if(res.currentBatch){
            this.nowDate
            const s=new Date(res.currentBatch.reportStartTime).getTime();
            const e=new Date(res.currentBatch.reportEndTime).getTime();
            if(this.nowDate>s&&this.nowDate<e){
              isDate=true;//上传中
            }
            this.isDate=isDate
          }
        });
    },

    //上传
    UploadChange(e, t) {
      const _t = this;
      if (t == "chugao") {
        this.chooseCourse.reportAtt = e.res;
        // this.thesis.thesisDegreeUrl = e.fullpath;
        // this.thesis.attSize = e.fileSize;
        // this.thesis.thesisDegreeSize = e.fileShowSize;
        // this.thesis.thesisDegreeFileName = e.filename;
      } else if (t == "chongchuan") {
        if (this.thesis.thesisAttUrl) {
          this.thesis.thesisAttUrl.push(e.fullpath)
          this.thesis.thesisDegreeAttSize.push(e.fileShowSize)
          this.thesis.thesisAttFileName.push(e.filename)
        } else {
          this.thesis.thesisAttUrl = [e.fullpath]
          this.thesis.thesisDegreeAttSize = [e.fileShowSize]
          this.thesis.thesisAttFileName = [e.filename]
        }
      }
      this.$forceUpdate()
    },
    beforeUpload(t) {
      if (t == "chugao") {
        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "chongchuan") {
        if (!this.thesis.thesisDegreeName) {
          this.$message({
            showClose: true,
            message: "请先填写论文标题。",
            type: "error",
          });
          return;
        }

        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
    },

    toSubmit() {
      const _t = this
      
      if (!_t.chooseCourse.reportAtt) {
        this.$message({
          showClose: true,
          message: "请先上传实践报告后再操作！",
          type: "error",
        });
        return;
      }
      _t.$http
            .post("/student/practiceReport", {
              id:_t.chooseCourse.id,reportAtt:_t.chooseCourse.reportAtt
            }, { isQs: true })
            .then(res => {
              if (res) {
                this.$message({
                  showClose: true,
                  message: "提交成功。",
                  type: "success",
                });
                _t.getInfo();
              }
            });
       
    },
    uploadAtt2() { },

  },
};
</script>

<style scoped lang="scss">
.tm_required {
  color: #f00;
  margin-left: 10px;
}

.editPhone .el-input {
  width: 250px;
}
</style>
